/*
  Experience Editor Component
*/
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import {
  removePhoto,
  createPhoto,
  repositionPhoto,
} from 'data_system/resource_portal/actions/experienceActions';

import PhotosForm from './PhotosForm';

class PhotoContainer extends Component {
  handleSubmit = (attrs) => {
    const { experience, createPhoto } = this.props;
    attrs.images.forEach((image) =>
      createPhoto({ experience_id: experience.id, image })
    );
  };

  handleRemoveImage = (assetId) => {
    const { removePhoto, experience, resourceId } = this.props;
    const attrs = { experienceId: experience.id, assetId, resourceId };
    removePhoto(attrs);
  };

  handleMoveImage = (assetId, oldPosition, newPosition) => {
    const { experience, resourceId } = this.props;
    const attrs = {
      experienceId: experience.id,
      assetId,
      resourceId,
      position: newPosition + 1,
      oldPosition,
    };
    const { repositionPhoto } = this.props;
    repositionPhoto(attrs);
  };

  render() {
    const { experience, images, imagesUploading, finalStepJustFinished, i18n } =
      this.props;
    return (
      <PhotosForm
        experience={experience}
        images={images}
        onSubmit={this.handleSubmit}
        handleRemoveImage={this.handleRemoveImage}
        handleMoveImage={this.handleMoveImage}
        imagesUploading={imagesUploading}
        allStepsDone={finalStepJustFinished}
        i18n={i18n}
      />
    );
  }
}

const mapStateToProps = (state) => {
  const { experienceReducer, auth } = state;
  return {
    experience: experienceReducer.experience,
    experienceUpdating: experienceReducer.experienceUpdating,
    images: experienceReducer.images,
    imagesUploading: experienceReducer.imagesUploading,
    finalStepJustFinished: experienceReducer.finalStepJustFinished,
    resourceId: auth.user.data.id,
  };
};

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators(
    { removePhoto, createPhoto, repositionPhoto },
    dispatch
  );
};

export default connect(mapStateToProps, mapDispatchToProps)(PhotoContainer);
